import { VersionSelector } from "../VersionSelector";
import { DevotionalHeader } from "./DevotionalHeader";

interface DevotionalVersionSelectorProps {
  date: string;
  topic: string;
  version: "classic" | "essential";
  onVersionChange: (version: "classic" | "essential") => void;
}

export const DevotionalVersionSelector = ({
  date,
  topic,
  version,
  onVersionChange,
}: DevotionalVersionSelectorProps) => {
  return (
    <>
      <DevotionalHeader
        date={date}
        topic={topic}
        version={version}
        onVersionChange={onVersionChange}
      />
    </>
  );
};